import { createStore } from 'vuex'
import auth from './modules/auth'
import category from './modules/category'
import projects from './modules/projects'
import ui from './modules/ui'
import customBackground from './modules/customBackground'
import zones from './modules/zones'
import subscription from './modules/subscription'

export default createStore({
        modules: {
                auth,
                category,
                projects,
                ui,
                customBackground,
                zones,
                subscription
        },
})
